:host {
  display: block;

  .wrapper {
    padding-inline: 0;
    padding-block: 0;
    background: none;
    border: 0;

    filter: drop-shadow(
      0 wink-rem(0.4) wink-rem(0.4) var(--indicator--filter-color, var(--semantic-color-background-surface-bold-pressed))
    );

    .indicator {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: var(--wink-indicator-padding, var-rem(--semantic-spacing-3xs));
      border: var(--indicator--border, var-rem(--semantic-border-none));
      border-color: var(--indicator--border-color, transparent);
      border-radius: var(--indicator--border-radius, var-rem(--semantic-spacing-none));
      background-color: var(--indicator--background-color, var(--semantic-color-background-canvas-overlapping));
      transition: transform 0.1s ease-in-out;

      &:hover {
        cursor: pointer;
        transform: scale(1.1);
        background-color: var(--indicator--hover--background-color, var(--semantic-color-background-canvas-default));
      }

      &:active {
        background-color: var(
          --indicator--active--background-color,
          var(--semantic-components-overlapping-button-color-background-surface-default)
        );
      }

      wink-icon {
        --wink-icon-color: var(--indicator--color, var(--semantic-components-overlapping-button-color-icon-default));

        height: auto;
      }
    }

    .indicator.is-disabled {
      @include state-disabled;
    }
  }
}
